import { fontFamilyBodyStack, sizeFontParagraphStep0 } from '@issuu/silkscreen';
import styled from 'styled-components';
export const StoryTypeBase = styled.article `
    font-size: ${sizeFontParagraphStep0};
    box-sizing: border-box;
    font-family: ${fontFamilyBodyStack};
    line-height: normal;
    color: rgba(0, 0, 0, 0.85);
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    z-index: 0;
    position: relative;
    overflow-wrap: break-word;
`;
export const StoryContent = styled.section `
    max-width: 720px;
    margin: 0 auto;
    padding: 0 1em;
    @media (min-width: 720px) {
        padding: 0;
    }
`;
const Story = styled(StoryTypeBase) `
    *,
    *::before,
    *::after {
        box-sizing: inherit;
    }
    @media (min-width: 700px) {
        font-size: 19px;
    }
`;
export default Story;
//# sourceMappingURL=Story.js.map